import type { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import type CrmFundraisingRecurringDonation from '@/types/serializers/CrmFundraisingRecurringDonation'
import {
  RECURRING_STATUS_LABELS,
  FREQUENCY_LABELS,
  STATUS_BADGE_VARIANT,
} from '@/lib/fundraising-labels'

export const recurringColumns: ColumnDef<CrmFundraisingRecurringDonation, unknown>[] = [
  {
    accessorKey: 'donor_name',
    header: 'Donateur',
    // Whole-row click opens the detail sheet; full page still reachable by URL.
    cell: ({ row }) => (
      <span className="font-medium">{row.original.donor_name}</span>
    ),
  },
  {
    accessorKey: 'status',
    header: 'Statut',
    meta: { sortKey: 'status' },
    cell: ({ row }) => {
      const label = typeof row.original.status === 'object' ? row.original.status.label : String(row.original.status)
      return (
        <Badge variant="outline">{label}</Badge>
      )
    },
  },
  {
    accessorKey: 'amount_per_installment_formatted',
    header: 'Montant / versement',
    meta: { sortKey: 'amount_per_installment_millimes' },
    cell: ({ row }) => (
      <span className="tabular-nums">{row.original.amount_per_installment_formatted}</span>
    ),
  },
  {
    accessorKey: 'frequency',
    header: 'Frequence',
    cell: ({ row }) => {
      const freq = typeof row.original.frequency === 'object'
        ? row.original.frequency.value
        : row.original.frequency
      const freqStr = String(freq)
      return FREQUENCY_LABELS[freqStr] ?? row.original.frequency.label ?? freqStr
    },
  },
  {
    accessorKey: 'start_date',
    header: 'Debut',
    meta: { sortKey: 'start_date' },
    cell: ({ row }) =>
      new Date(row.original.start_date).toLocaleDateString('fr-FR'),
  },
  {
    accessorKey: 'end_date',
    header: 'Fin',
    cell: ({ row }) =>
      row.original.end_date
        ? new Date(row.original.end_date).toLocaleDateString('fr-FR')
        : '-',
  },
]
